<template>
  <i :class="`iconfont icon-${iconClass}`"></i>
<!--  <svg class="svg-icon" aria-hidden="true">-->
<!--    <use :xlink:href="iconName"></use>-->
<!--  </svg>-->
</template>

<script>
// 需要下载的iconfont未js 即未syboll才有效
  export default {
    name: 'iconSvg',
    props: {
      iconClass: {
        type: String,
        required: true,
        default: 'circle-XS'
      }
    },
    computed: {
      iconName() {
        return `#icon-${this.iconClass}`
      }
    }
  }
</script>

<style>
  .svg-icon {
    font-size: 12px;
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
</style>
